import React, { useState } from "react";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faUser,
  faChair,
  faCouch,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../constants/styles";

import ProjectLocations from "./components/ProjectLocations";
import ProjectPeople from "./components/ProjectPeople";
import ProjectAssets from "./components/ProjectAssets";
import ProjectContractors from "./components/ProjectContractors";
import ProjectMoves from "./components/ProjectMoves";
import BuildingNavigator from "./components/BuildingNavigator";
import MoveLocationPopup from "./components/MoveLocationPopup";
import ProjectKpiDrawer from "./components/ProjectKpiDrawer";


export default function ProjectEdit() {

  var [showEditProject, setShowEditProject] = useState(false);
  var [showMovePopup, setShowMovePopup] = useState(false);
  
  const people = [
    {
      id: 1,
      name: "Jane Smith",
      department: "Finance",
      deskCode: "RF.08.M12.06",
      assets: 2,
      status: "Assigned"
    },
    {
      id: 2,
      name: "Mark Thompson",
      department: "IT",
      deskCode: "RF.08.M10.03",
      assets: 3,
      status: "Assigned"
    },
    {
      id: 3,
      name: "Sarah Collins",
      department: "HR",
      deskCode: null,
      assets: 1,
      status: "Unallocated"
    },
    {
      id: 4,
      name: "David Patel",
      department: "Operations",
      deskCode: "RF.08.N11.10",
      assets: 4,
      status: "Assigned"
    },
    {
      id: 5,
      name: "Emma Wright",
      department: "Marketing",
      deskCode: "RF.08.N12.05",
      assets: 2,
      status: "Assigned"
    },
    {
      id: 6,
      name: "Tom Reynolds",
      department: "IT",
      deskCode: null,
      assets: 2,
      status: "Pending"
    },
    {
      id: 7,
      name: "Lucy Bennett",
      department: "Legal",
      deskCode: "RF.08.K10.01",
      assets: 1,
      status: "Assigned"
    },
    {
      id: 8,
      name: "Chris O’Neill",
      department: "Facilities",
      deskCode: null,
      assets: 5,
      status: "Unallocated"
    },
    {
      id: 9,
      name: "Hannah Brooks",
      department: "Sales",
      deskCode: "RF.08.M12.07",
      assets: 2,
      status: "Assigned"
    },
    {
      id: 10,
      name: "Paul Edwards",
      department: "Leadership",
      deskCode: "RF.08.N9.02",
      assets: 3,
      status: "Assigned"
    }
  ];
  
  const assets = [

    {
      id: 1,
      type: "Desk",
      assetClass: "Furniture",
      name: "Height Adjustable Desk – A12",
      assetNumber: "DESK-00123",
      manufacturer: "Steelcase",
      model: "Ology",
      serialNumber: "SC-OLG-44821",
      status: "Assigned"
    },

    {
      id: 2,
      type: "Chair",
      assetClass: "Furniture",
      name: "Ergonomic Task Chair – B07",
      assetNumber: "CHAIR-00456",
      manufacturer: "Herman Miller",
      model: "Aeron",
      serialNumber: "HM-AER-99214",
      status: "Assigned"
    },

    {
      id: 3,
      type: "Monitor",
      assetClass: "IT Equipment",
      name: "27\" UHD Monitor – Finance",
      assetNumber: "MON-00987",
      manufacturer: "Dell",
      model: "UltraSharp U2720Q",
      serialNumber: "DL-U27-55832",
      status: "Pending"
    },

    {
      id: 4,
      type: "Laptop",
      assetClass: "IT Equipment",
      name: "Logistics Supervisor Laptop",
      assetNumber: "LAP-00231",
      manufacturer: "HP",
      model: "EliteBook 850 G8",
      serialNumber: "HP-EB-77120",
      status: "Assigned"
    },

    {
      id: 5,
      type: "Docking Station",
      assetClass: "IT Equipment",
      name: "USB-C Dock – Dispatch Office",
      assetNumber: "DOCK-00089",
      manufacturer: "Lenovo",
      model: "ThinkPad USB-C Dock Gen 2",
      serialNumber: "LN-DOCK-22091",
      status: "Unallocated"
    },

    {
      id: 6,
      type: "Pedestal",
      assetClass: "Storage",
      name: "Under-Desk Pedestal – 3 Drawer",
      assetNumber: "PED-00314",
      manufacturer: "Bisley",
      model: "Note Pedestal",
      serialNumber: "BS-NP-66712",
      status: "Assigned"
    },

    {
      id: 7,
      type: "Locker",
      assetClass: "Storage",
      name: "Personal Locker – Warehouse West",
      assetNumber: "LOCK-00176",
      manufacturer: "Probe",
      model: "Personal Locker 1800",
      serialNumber: "PR-PL-88230",
      status: "Pending"
    },

    {
      id: 8,
      type: "Meeting Table",
      assetClass: "Furniture",
      name: "Meeting Table – Boardroom",
      assetNumber: "MT-00042",
      manufacturer: "Senator",
      model: "Sprint Table",
      serialNumber: "SN-SPR-11902",
      status: "Assigned"
    },

    {
      id: 9,
      type: "Video Conferencing",
      assetClass: "AV Equipment",
      name: "Conference Camera – Boardroom",
      assetNumber: "AV-00388",
      manufacturer: "Logitech",
      model: "Rally Plus",
      serialNumber: "LG-RLY-55210",
      status: "Unallocated"
    },

    {
      id: 10,
      type: "Printer",
      assetClass: "IT Equipment",
      name: "Warehouse Label Printer",
      assetNumber: "PRN-00112",
      manufacturer: "Zebra",
      model: "ZT410",
      serialNumber: "ZB-ZT4-33018",
      status: "Assigned"
    },

    {
      id: 11,
      type: "Scanner",
      assetClass: "IT Equipment",
      name: "Handheld Barcode Scanner",
      assetNumber: "SCAN-00491",
      manufacturer: "Honeywell",
      model: "CK65",
      serialNumber: "HW-CK65-90912",
      status: "Pending"
    },

    {
      id: 12,
      type: "Whiteboard",
      assetClass: "Facilities",
      name: "Mobile Whiteboard – Ops Area",
      assetNumber: "WB-00073",
      manufacturer: "Nobo",
      model: "Diamond Mobile",
      serialNumber: "NB-DM-44801",
      status: "Unallocated"
    }

  ];
  
  const contractors = [
    {
      id: 1,
      name: "ABC Removals Ltd",
      trade: "Removal Contractor",
      contact: "John Harris",
      insuranceValid: true,
      compliance: "Compliant"
    },
    {
      id: 2,
      name: "SparkRight Electrical",
      trade: "Electrical Contractor",
      contact: "Sarah Milton",
      insuranceValid: true,
      compliance: "Expiring"
    },
    {
      id: 3,
      name: "NetCore Solutions",
      trade: "Data / Network",
      contact: "Paul Edwards",
      insuranceValid: true,
      compliance: "Compliant"
    },
    {
      id: 4,
      name: "OfficeForm Installations",
      trade: "Furniture Installer",
      contact: "Mark Benson",
      insuranceValid: false,
      compliance: "Non-Compliant"
    },
    {
      id: 5,
      name: "SecureTech Systems",
      trade: "Security & Access Control",
      contact: "Rachel Moore",
      insuranceValid: true,
      compliance: "Compliant"
    }
  ];




  return (
    <div style={{ marginLeft: "60px", marginTop: "60px"}}>
      <Header />
      <LeftMenu />
	  <MoveLocationPopup
	    open={showMovePopup}
	    mode="ORIGIN" // or "DESTINATION"
	    onClose={() => setShowMovePopup(false)}
	    onConfirm={(moveZone) => console.log(moveZone)}
	  />
      {/* ================= PROJECT CONTEXT HEADER ================= */}
      <div
        style={{
          top: "80px",
          width: "calc(100vw - 220px)", // ⬅ spans nav + content
          padding: "26px 32px",
          borderBottom: "1px solid #e6e6e6",
          boxShadow: "0 6px 10px -8px rgba(0,0,0,0.25)",
          zIndex: 1000,
		  marginTop:'20px',
		  marginLeft:'20px',
		  borderRadius:'20px',
		  background:GREY_GRADIENT_PANEL_BACKGROUND
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
			width:'calc(100% - 0px)'
          }}
        >

          {/* LEFT – PROJECT DETAILS */}
          <div style={{ display: "flex", gap: "40px", alignItems: "center" }}>

            {/* Name + edit */}
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <FontAwesomeIcon
                  icon={faPen}
                  title="Edit project"
                  style={{
                    cursor: "pointer",
                    color: "#2F80ED",
                    fontSize: "15px"
                  }}
                  onClick={function () {
                    setShowEditProject(true);
                  }}
                />

                <div style={{ fontSize: "18px", fontWeight: 600 }}>
                  HQ Consolidation
                </div>
              </div>

              <div style={{ fontSize: "13px", color: "#666", marginTop: "4px" }}>
                ACME Appliances
              </div>
            </div>

            <div>
              <div style={{ fontSize: "13px", color: "#888" }}>Sponsor</div>
              <div style={{ fontSize: "14px" }}>Jane Smith</div>
            </div>

            <div>
              <div style={{ fontSize: "13px", color: "#888" }}>Dates</div>
              <div style={{ fontSize: "14px" }}>Jan 2025 → Jun 2025</div>
            </div>
          </div>

          {/* RIGHT – ICON METRICS */}
          <div style={{ display: "flex", gap: "34px", alignItems: "center", marginRight:'200px' }}>

            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon icon={faUser} style={{ color: "#2F80ED", fontSize: "22px" }} />
              <div style={{ fontSize: "18px", fontWeight: 600 }}>120 → 140</div>
              <div style={{ fontSize: "11px", color: "#999" }}>People</div>
            </div>

            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon icon={faChair} style={{ color: "#2F80ED", fontSize: "22px" }} />
              <div style={{ fontSize: "18px", fontWeight: 600 }}>110 → 130</div>
              <div style={{ fontSize: "11px", color: "#999" }}>Desks</div>
            </div>

            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon icon={faCouch} style={{ color: "#2F80ED", fontSize: "22px" }} />
              <div style={{ fontSize: "18px", fontWeight: 600 }}>420 → 500</div>
              <div style={{ fontSize: "11px", color: "#999" }}>Assets</div>
            </div>

          </div>
        </div>
      </div>

      {/* ================= BODY ================= */}
      <div
        style={{
          display: "flex",
          width: "calc(100vw - 140px)",
          minHeight: "calc(100vh - 90px)"
        }}
      >

        {/* LEFT – BUILDING NAVIGATOR */}
		<div
		  style={{
		    width: "316px",
		    borderRadius:"10px",
			backgroundColor:ADMIN_PANEL_BACKGROUND_COLOR,
		    position: "sticky",
		    top: 169,
		    alignSelf: "flex-start",
		    height: "calc(100vh - 140)",
			overflowX:'hidden',
			overflowY:'auto',
			boxShadow: "0 6px 10px -8px rgba(0,0,0,0.85)",
			marginTop:'20px',
			marginLeft:'20px'
		  }}
		>
		  <BuildingNavigator />
		</div>

        {/* RIGHT – MAIN CONTENT */}
        <div style={{ flex: 1, padding: "0px 0px", marginTop:'0px' }}>

          {/* LOCATIONS */}
          <ProjectLocations setShowMovePopup={setShowMovePopup}/>

          {/* PEOPLE */}
          <ProjectPeople people={people}/>

		  {/* ASSETS */}
		  <ProjectAssets assets={assets}/>
		  
		  {/* CONTACTORS */}
		  <ProjectContractors contractors={contractors}/>

		  {/* MOVES */}
		  <ProjectMoves/>

        </div>
      </div>

      {/* ================= KPI DRAWER ================= */}
     <ProjectKpiDrawer />

      {/* ================= EDIT MODAL ================= */}
      {showEditProject && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div style={{ width: "420px", background: "#fff", borderRadius: "6px", padding: "20px" }}>
            <h3>Edit Project</h3>
            <div style={{ height: "120px", background: "#f4f6f8", borderRadius: "4px" }} />

            <div
              style={{ position: "absolute", top: "12px", right: "12px", cursor: "pointer" }}
              onClick={function () {
                setShowEditProject(false);
              }}
            >
              <FontAwesomeIcon icon={faTimes}/>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
